<script lang="ts">
	import { onDestroy, onMount } from "svelte"
	import { TestStation } from "./TestStationController"
	import { DataHandlerDeviceAdmin, Device } from "luxedo-data"
	import Header from "../../reusable/Header.svelte"
	import LoadingSpinner from "../../reusable/loaders/LoadingSpinner.svelte"
	import { Toast } from "toaster"
	import TestStationConnected from "./TestStation_Connected.svelte"
	import TestStationConfiguringNewDevice from "./TestStation_ConfigNewDevice.svelte"
	import { RefreshIcon } from "luxedo-icons"
	import { Link } from "svelte-routing"
	import TestStationConfigNewDevice from "./TestStation_ConfigNewDevice.svelte"

	let activeDevice: Device = $state()

	let newPassword: string
	let newDeviceID: number

	let loadingText = $state("Searching for template device")
	let isNewDeviceConfiguring = $state(false)

	TestStation.subscribe((ctx) => {
		activeDevice = ctx.activeDevice
		newPassword = ctx.newPass
		newDeviceID = ctx.newID
		isNewDeviceConfiguring = ctx.processingNewDevice

		if (newDeviceID > 4) loadingText = `Connecting to device #${newDeviceID}`
		else loadingText = `Searching for template device`
	})

	async function connectTo(search: string) {
		TestStation.reset(false)
		if (!search) return

		const id = Number(search)
		if (isNaN(id)) Toast.error(`No device with an ID of ${id}.`)

		loadingText = `Connecting to device #${id}`
		await TestStation.waitForDevice(id)
		Toast.success(`Connected to device #${id}`)
	}

	function refresh() {
		TestStation.reset()
		TestStation.initialize()
	}

	onMount(refresh)
	onDestroy(TestStation.reset)
</script>

<Header heading="Test Station" onSearch={connectTo} searchPlaceholder="Device ID" />
<button class="small only-icon" id="reset-icon" title="Reset" onclick={refresh}>
	<RefreshIcon />
</button>

<main>
	{#if isNewDeviceConfiguring}
		<TestStationConfigNewDevice />
	{:else if !activeDevice}
		<LoadingSpinner {loadingText} />
	{:else}
		<div class="connected-wrapper">
			<h1>Succesfully connected</h1>
			<TestStationConnected />
		</div>
	{/if}
	<footer>
		<div>
			Other tools:
			<Link to="/admin/mass-update">Mass Update</Link>
		</div>
	</footer>
</main>

<style>
	main {
		--loader-color: var(--color-accent);
		--loader-width: 20vw;

		width: 100%;
		height: calc(100vh - var(--header-height));
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	footer {
		position: absolute;
		bottom: 1rem;
	}

	.connected-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	h1 {
		font-size: var(--text-h3);
	}

	#reset-icon {
		position: absolute;
		right: 16rem;
		top: 0.5rem;
	}
</style>
